// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9o-0";
export var optionCard = "_9o-1";